import { Button } from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';

import { Route } from '@/constants';
import { TPurchaseReturnListItem } from '@/features/slice/purchase-return';
import { formatCurrencyInBDT } from '@/utils';

export const purchaseReturnListColumn: ColumnDef<TPurchaseReturnListItem>[] = [
    {
        accessorKey: 'invoice_number',
        header: () => <div>Invoice Number</div>,
        cell: ({ row }) => (
            <Link to={`${Route.PURCHASE_RETURNS}/${row.original.id}`}>
                <span
                    className={
                        'font-medium hover:cursor-pointer hover:underline'
                    }
                >
                    {row.original.purchase_invoice_number}
                </span>
            </Link>
        ),
    },

    {
        accessorKey: 'created_at',
        header: () => <div>Date</div>,
        cell: ({ row }) => (
            <span>
                {new Date(row.original.created_at).toLocaleDateString()}
            </span>
        ),
    },

    {
        accessorKey: 'supplier_name',
        header: () => <div>Supplier</div>,
        cell: ({ row }) => (
            <div>
                <Link
                    to={`${Route.SUPPLIERS}/${row.original.supplier_id}`}
                    className={'duration-150 hover:underline'}
                >
                    {row.original.supplier_name}
                </Link>
            </div>
        ),
    },

    {
        accessorKey: 'total_items',
        header: () => <span className={'block text-right'}>Total Items</span>,
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {row.original.total_items}
            </span>
        ),
    },

    {
        accessorKey: 'payment_total_price',
        header: () => <span className={'block text-right'}>Total Price</span>,
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {formatCurrencyInBDT(row.original.payment_total_price)}
            </span>
        ),
    },

    {
        accessorKey: 'return_reason',
        header: () => <span className={'block text-left'}>Return Reason</span>,
        cell: ({ row }) => (
            <span className={'block text-left'}>
                {row.original.return_reason}
            </span>
        ),
    },

    {
        accessorKey: 'actions',
        header: () => <span className={'block text-right'}>Actions</span>,
        cell: ({ row }) => (
            <div className={'flex justify-end'}>
                <Link
                    to={`${Route.PURCHASE_RETURNS}/${row.original.id}`}
                    className={''}
                >
                    <Button
                        type={'button'}
                        variant={'outline'}
                        className={''}
                        size={'sm'}
                    >
                        View Details
                    </Button>
                </Link>
            </div>
        ),
    },
];
